import React from 'react';

const RunbookFilterIcon = (props) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M6.77631 8.23012V13.3168C6.77631 13.5066 6.88377 13.68 7.05373 13.7645L8.69071 14.5783C9.0231 14.7435 9.41329 14.5017 9.41329 14.1306V8.23427C9.41329 7.99217 9.50112 7.75829 9.66049 7.57603L14.7402 1.76662C15.0229 1.44329 14.7933 0.9375 14.3638 0.9375H7.68646H1.90378C1.476 0.9375 1.24576 1.43979 1.52499 1.76387L6.53389 7.57738C6.69029 7.75889 6.77631 7.99052 6.77631 8.23012Z" stroke="currentColor" strokeLinecap="round"/>
    </svg>
);

export default RunbookFilterIcon;
